module.exports = __webpack_public_path__ + "components/wind-icon/static/ENE@2x-612bcffa4ab5e8f0f0c4570ba1a04515.png";